$(document).ready(function () {
  $(document).on("submit", ".ajax-add-to-cart-form", function (event) {
    event.preventDefault();
    var ID = $(this).find("#quantity").attr("value");
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: ID,
        id: $(this).find('[name="id"]').attr("value"),
      },
      dataType: "json",
      success: function (data) {
        function updateCart() {
          console.log("this function is working PROPERLY");
          fetch("/cart/?view=drawer")
            .then((response) => response.text())
            .then((cartData) => {
              let parser = new DOMParser();
              htmlData = parser.parseFromString(cartData, "text/html");
              $("#sidebar-cart").html($(htmlData).find('#sidebar-cart').html());
            })
            .then(document.querySelector('[aria-label="Open cart"]').click());
        }
        updateCart();
        $("#CartCount span:first").text(data.quantity);
        console.log(data.quantity);
        
        
      },
    });
  });
});

